import { GETBABYPRESSADATAFILTER_TYPES } from '../actions/getBabypressaDataFilter'
import reducer, { defaultState } from './requests'
const Reducer = (state = defaultState, action) => {
    let requestReducer = reducer(GETBABYPRESSADATAFILTER_TYPES)(state, action)
    if (requestReducer !== null) return requestReducer
    switch (action.type) {
        default:
            return state
    }
}
export default Reducer
